// extracted by mini-css-extract-plugin
export default {"process":"problem-solution_process__QsHX7","tile":"problem-solution_tile__pqaux","divider":"problem-solution_divider__A+64a","caption":"problem-solution_caption__4GqHN"};